import axios from "axios";
export async function get(assessment_id: string, type: number) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/context/assessment/"+assessment_id+"/"+type);
    return response.data;
}

export async function update(assessment_id: string, data: FormData, type: number) {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/context/assessment/"+assessment_id+"/store/"+type,data);
    return response.data;
}